import type { Ref } from "react";

// Vector exported from Figma Tag close glyph (node Close, 12×12) — do not redraw.
export const TagCloseIcon = ({
    className,
    ref,
}: Readonly<{ className?: string; ref?: Ref<SVGSVGElement> }>) => (
    <svg
        ref={ref}
        className={className}
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M2.5 2.5L9.5 9.5M9.5 2.5L2.5 9.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
